import BaseView from './_BaseView'
import BaseSlider from '../blocks/BaseSlider'




/* VIEW: HOME
----------------------------------------------------------------------------------------------------*/

export default class Home extends BaseView {

    constructor(props) {
        super({ ...props, namespace: '.home' })


        this.$els = {
            //
        }


        this.bindEvents()
    }


    bindEvents() {
        // 
    }


    destroy() {
        super.destroy()

        if (this.slider) this.slider.destroy()
    }




    /* Handlers
    --------------------------------------------------------- */



    /* Actions
    --------------------------------------------------------- */

    initSlider() {
        this.slider = new BaseSlider('.slider')
    }




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



